import withQueryParams from "../../utils/withQueryParams";
import productPageBaseUri from "../../utils/productPageBaseUri";

class StockServiceClient {
  constructor(integrationService) {
    this._integrationService = integrationService;
  }

  fetchStockAvailability = async (productCode, quantity, branchId) => {

    const stockAvailabilityUri = withQueryParams(
      `${productPageBaseUri}api/products/${productCode}/stockAvailability`,
      {
        requiredQuantity: quantity,
        branchId: branchId
      });

    return this._integrationService.read({
      url: stockAvailabilityUri,
      method: "GET",
      credentials: "include"
    });
  }
}

export default StockServiceClient;
